import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { SiteProvider } from './context/SiteContext';
import HomePage from './pages/HomePage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AllTrips from './pages/AllTrips';
import TripDetails from './pages/TripDetails';
import Corporate from './pages/Corporate';
import Events from './pages/Events';
import ExperienceDetails from './pages/ExperienceDetails';
import PackageDetails from './pages/PackageDetails';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <SiteProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/trips" element={<AllTrips />} />
        <Route path="/trips/:slug" element={<TripDetails />} />
        <Route path="/corporate" element={<Corporate />} />
        <Route path="/experiences" element={<Events />} />
        <Route path="/experiences/:slug" element={<ExperienceDetails />} />
        <Route path="/corporate/packages/:slug" element={<PackageDetails />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </SiteProvider>
  );
}
